"use client";
import { Button, Typography } from "@cappelendamm/design-system/react";
import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { PiCheck, PiCopy } from "react-icons/pi";
import { useTrackEvent } from "@/tracking/TrackingContext";

export function CopyIsbnButton({ isbn }: { isbn: string }) {
  const trackEvent = useTrackEvent();
  const [copied, setCopied] = useState(false);
  const resetTimeout = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => () => clearTimeout(resetTimeout.current), []);

  const copyIsbn = async () => {
    try {
      await navigator.clipboard.writeText(isbn);
    } catch (err) {
      console.error("Failed to copy ISBN: ", err);
      return;
    }
    trackEvent({ eventName: "isbn_copied", sku: isbn });
    setCopied(true);
    clearTimeout(resetTimeout.current);
    resetTimeout.current = setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="hidden w-full justify-center md:flex">
      <Button
        type="button"
        variant="tertiary-small"
        onClick={copyIsbn}
        className="min-h-0 py-1"
      >
        {copied ? (
          <PiCheck aria-hidden size={20} />
        ) : (
          <PiCopy aria-hidden size={20} />
        )}
        {/* Both labels share one grid cell so the button keeps its width */}
        <Typography
          as="span"
          variant="body-sm-tight"
          className="grid text-left"
        >
          <span
            className={classNames("col-start-1 row-start-1", {
              invisible: copied,
            })}
          >
            Kopier ISBN
          </span>
          <span
            className={classNames("col-start-1 row-start-1", {
              invisible: !copied,
            })}
          >
            Kopiert!
          </span>
        </Typography>
      </Button>
      <span role="status" className="sr-only">
        {copied ? `ISBN ${isbn} kopiert` : null}
      </span>
    </div>
  );
}
